export default __webpack_public_path__ + "static/media/join-avatar-1.771b899b.png";